import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import SecondaryButton from "../../../../common/ui/SecondaryButton";
import LinkSvg from "../../../../common/svgs/LinkSvg";

interface PrescriptionLinkButtonProps {
  /** The prescription detail route this record belongs to. */
  to: string;
}

/**
 * "Prescription" link beside a History record's title (lab order, service),
 * leading to the prescription it was ordered from. A `SecondaryButton` at the
 * status badge's metrics, so the two sit at one height in the title row.
 */
const PrescriptionLinkButton: React.FC<PrescriptionLinkButtonProps> = ({ to }) => {
  const theme: Theme = useTheme();
  return (
    <SecondaryButton
      to={to}
      label="Prescription"
      icon={<LinkSvg color={theme.colors_ds.PRIMARY_ICON_MAIN} />}
      sx={{
        height: "auto",
        padding: "4px 8px",
        fontSize: "12px",
        lineHeight: "1.6",
      }}
    />
  );
};

export default PrescriptionLinkButton;
